import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "../components/Nav";
import Hero from "../sections/Hero";
import Marquee from "../sections/Marquee";
import Why from "../sections/Why";
import Experience from "../sections/Experience";
import Host from "../sections/Host";
import Connections from "../sections/Connections";
import Sponsors from "../sections/Sponsors";
import InterestSection from "../sections/InterestSection";
import Welcome from "../sections/Welcome";
import Classes from "../sections/Classes";
import Sailings from "../sections/Sailings";
import RenewalOverview from "../sections/RenewalOverview";
import Faq from "../sections/Faq";
import Footer from "../sections/Footer";
import AskChaplain from "../components/AskChaplain";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-cream" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Why />
        <Welcome />
        <Experience />
        <Sailings />
        <RenewalOverview />
        <Classes />
        <Host />
        <Connections />
        <Sponsors />
        <InterestSection />
        <Faq />
      </main>
      <Footer />
      <AskChaplain />
    </div>
  );
}
